module.exports = __webpack_public_path__ + "static/media/hotdog.1ec8b781.svg";